import React, { useState, useEffect, useRef } from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Typography,
  Dialog,
  DialogContentText,
  Grid,
  FormControlLabel,
  Checkbox,
  useTheme,
} from '@mui/material';

import { CloseButton } from './styles';
import TermsConditions from '@shared/components/TermsConditions';
import { ID_SITE } from '@shared/conf/env';

export default function TermsAndConditionsCheckbox({
  formik,
  fieldName,
  dialogText,
}) {
  const [open, setOpen] = useState(false);
  const descriptionRef = useRef(null);
  const theme = useTheme();

  const handleClose = () => setOpen(false);
  const handleToggle = () =>
    formik.setFieldValue(fieldName, !formik.values[fieldName]);

  const error =
    formik.touched[fieldName] && formik.errors[fieldName]
      ? formik.errors[fieldName]
      : null;

  useEffect(() => {
    if (open && descriptionRef.current) {
      descriptionRef.current.focus();
    }
  }, [open]);

  return (
    <>
      <Grid item xs={12} sx={{ ml: '1vw' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formik.values[fieldName]}
              onChange={handleToggle}
              name={fieldName}
              sx={{
                color: theme.tertiary,
                '&.Mui-checked': { color: theme.tertiary },
                transform: { xs: 'scale(0.9)', md: 'scale(1.1)' },
                p: '8px',
                pl: { xs: '8px', md: 0 },
              }}
            />
          }
          label={
            <Typography sx={{ color: '#000', fontSize: { xs: 16, md: 18 } }}>
              Leí y acepto{' '}
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  color: theme.tertiary,
                  cursor: 'pointer',
                  '&:hover': { textDecoration: 'underline' },
                }}
                onClick={() => setOpen(true)}
              >
                los términos y condiciones generales
              </Typography>
              {error && (
                <Typography
                  component="span"
                  sx={{ color: 'red', fontSize: { xs: 16, md: 18 } }}
                >
                  {` (${error})`}
                </Typography>
              )}
            </Typography>
          }
        />
      </Grid>

      <Dialog
        open={open}
        maxWidth="md"
        onClose={handleClose}
        scroll="paper"
        tabIndex={-1}
      >
        <DialogTitle>
          <Typography
            align="center"
            sx={{ fontWeight: 'bold', fontSize: '16px' }}
          >
            {dialogText}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText ref={descriptionRef} tabIndex={-1}>
            <TermsConditions siteId={ID_SITE} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CloseButton onClick={handleClose}>Cerrar</CloseButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
